import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {NavController, NavParams, Platform, PopoverController} from "ionic-angular";
import {BemerkungstextvorlagenComponent} from "../bemerkungstextvorlagen/bemerkungstextvorlagen";
import {ModalNavPage} from "../../pages/modal-nav/modal-nav";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Camera} from "@ionic-native/camera";
import {GlobalProvider} from "../../providers/global/global";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {blobToDataURL} from "blob-util";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {AddFotoPopoverComponent} from "../add-foto-popover/add-foto-popover";
import {DeleteFotoPopoverComponent} from "../delete-foto-popover/delete-foto-popover";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {Subscription} from "rxjs/Subscription";
import * as moment from "moment";
import * as uuid from "uuid/v1";
import {AuditService} from "../../store/audit/audit.service";
import {ProtocolService} from "../../store/protocol/protocol.service";
import {ProtocolEntity, ProtocolInspectionPointEntity} from "../../store/protocol/protocol.entity";
import {AuditEntity} from "../../store/audit/audit.entity";

/**
 * Generated class for the PruefpunktAddInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@AutoUnsubscribe()
@Component({
  selector: 'pruefpunkt-add-info',
  templateUrl: 'pruefpunkt-add-info.html'
})
export class PruefpunktAddInfoComponent implements OnChanges{

  text: string;
  contentArea = BemerkungstextvorlagenComponent;

  public inspectionPoint: ProtocolInspectionPointEntity;
  private _sectionName: string;
  private _protokoll: any;
  private protokoll: ProtocolEntity;
  private audit: AuditEntity;
  private bilder$: BehaviorSubject<Array<any>>;
  public bilder: Array<{fileName: string, file: string}> = [];
  public isBrowser: boolean = false;
  public isOwner: boolean = false;

  private _bilderSubscription: Subscription;
  private _protokollSubscription: Subscription;
  public today = moment().format('YYYY-MM-DD');
  public maxDate = moment().add(10, 'y').format('YYYY-MM-DD');

  constructor(private modalNav: ModalNavPage,
              private navParams: NavParams,
              private navCtrl: NavController,
              private dataProvider: DataProvider,
              private popoverCtrl: PopoverController,
              private auditService: AuditService,
              private protocolService: ProtocolService,
              private loadingController: LoadingServiceProvider,
              private camera: Camera,
              private platform: Platform,
              public globalProvider: GlobalProvider,
  ) {
    let self = this;
    this.inspectionPoint = navParams.get('inspectionPoint');
    this._protokoll = navParams.get('protocol');
    this._sectionName = navParams.get('sectionName');
    this.audit = navParams.get('audit');
    this.isBrowser = this.globalProvider.isBrowser();
    this.isOwner = this._protokoll.ownerId === this.globalProvider.user.uuid;

    this._protokollSubscription = this.protocolService.getById(this._protokoll._id)
      .subscribe((protocol: ProtocolEntity) => {
        this.protokoll = protocol;

        let found = false;
        for(let i = 0; i < this.protokoll.sections.length; i++){
          let _section = this.protokoll.sections[i];
          for(let j = 0; j < _section.inspectionPoints.length; j++){
            if(_section.inspectionPoints[j].propertyName === this.inspectionPoint.propertyName){
              this.inspectionPoint = _section.inspectionPoints[j];
              found = true;
              break;
            }
          }
          if(found){
            break;
          }
        }
      })

    // this._protokollSubscription = this.protokollProvider.getById(this._protokoll._id)
    //   .subscribe((proto) => {
    //     this.protokoll = proto;
    //
    //     let found = false;
    //     for(let i = 0; i < this.protokoll.sections.length; i++){
    //       let _section = this.protokoll.sections[i];
    //       for(let j = 0; j < _section.inspectionPoints.length; j++){
    //         if(_section.inspectionPoints[j].propertyName === this.inspectionPoint.propertyName){
    //           this.inspectionPoint = _section.inspectionPoints[j];
    //           found = true;
    //           break;
    //         }
    //       }
    //       if(found){
    //         break;
    //       }
    //     }
    //
    //   });

    if(!this.inspectionPoint.pictures){
      this.inspectionPoint.pictures = [];
    }
    this.bilder$ = new BehaviorSubject(this.inspectionPoint.pictures);
    this._bilderSubscription = this.bilder$.subscribe((bilder) => {
      bilder.forEach((bildId) => {
        this.dataProvider.getAttachment(this.protokoll._id, bildId)
          .then((rawBild) => {
            blobToDataURL(rawBild)
              .then((base64) => {
                let _bild = {fileName: bildId, file: base64};
                let contains = false;
                for(let i = 0; i < self.bilder.length; i++){
                  if(self.bilder[i].fileName == bildId){
                    contains = true;
                    break;
                  }
                }

                if (!contains){
                  self.bilder.push({fileName: bildId, file: base64});
                }
              })
          })
      })
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('there were some changes');
  }

  public close(): void {
    this.modalNav.dismissModal();
  }

  public delete(bild: any){

    if(!this.isOwner)
      return;

    let _popover = this.popoverCtrl.create(DeleteFotoPopoverComponent);
    _popover.onDidDismiss((toDelete) => {
      if(toDelete){
        this.dataProvider.removeAttachment(this.protokoll._id, bild.fileName)
          .then((success) => {
            this.inspectionPoint.pictures = this.inspectionPoint.pictures.filter((_bild) => {
              return _bild !== bild.fileName;
            }, (error) => {
              this.loadingController.dismiss()
            });
            this.protocolService.set(this.protokoll, false)
              .then(() => {

                this.bilder = this.bilder.filter((_bild) => {
                  return this.inspectionPoint.pictures.indexOf(_bild.fileName) !== -1;
                });
                this.bilder$.next([...this.inspectionPoint.pictures]);
                this.loadingController.dismiss();
              }, (error) => {
                this.loadingController.dismiss();
              });
          });
      }
    });

    _popover.present({
      ev: event
    });
  }

  public showBemerkungstextVorlagen(selectedVorlage?: string): void {
    this.navCtrl.push(BemerkungstextvorlagenComponent, {pruefpunkt: this.inspectionPoint, selectedVorlage: selectedVorlage, protokoll: this.protokoll});
  }

  public deleteAnmerkung(comment: string): void {
    this.inspectionPoint.comments = this.inspectionPoint.comments.filter((_comment) => {
      return _comment !== comment;
    });

    this.protocolService.set(this.protokoll, false);
    // this.dataProvider.updateDocument(this.protokoll);
  }

  public addFoto(event): void {

    if(!this.isOwner)
      return;

    let _popover = this.popoverCtrl.create(AddFotoPopoverComponent);
    _popover.onDidDismiss((response) => {
      if(response){
        switch (response.type) {
          case 'camera':
            this._openCamera();
            break;
          case 'album':
            this._openImagePicker();
            break;
          case 'filePicker':
            this._processFile(response.data);
            break;
        }
      }
    });

    _popover.present({
      ev: event
    });
  }

  private _openImagePicker():void {

    let self = this;
    const options = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY
    };

    if(this.platform.is('cordova')){
      this.camera.getPicture(options).then((imageData) => {
        let base64Image = 'data:image/jpeg;base64,' + imageData;
        fetch(base64Image).then((_data) => {
          return _data.blob();
        }, (error) => {
          this.loadingController.dismiss();
        }).then((_blob) => {
          // got a blob
          // let fileName = Date.now()
          let fileName = uuid();
          if(!this.inspectionPoint.pictures){
            this.inspectionPoint.pictures = [];
          }
          this.inspectionPoint.pictures.push(fileName);

          this.protocolService.set(this.protokoll)
            .then((success) => {
              this.dataProvider.saveAttatchment(this.protokoll._id, fileName.toString(), _blob, 'image/png')
                .then((success) => {
                  console.log('successfully added picture');
                  this.bilder$.next([...this.inspectionPoint.pictures]);
                  this.loadingController.dismiss();
                }, (error) => {
                  console.log(error);
                  this.loadingController.dismiss();
                });
            }, (error) => {
              this.loadingController.dismiss();
            });

          // this.dataProvider.updateDocument(this.protokoll)
          //   .then((success) => {
          //     this.dataProvider.saveAttatchment(this.protokoll._id, fileName.toString(), _blob, 'image/png')
          //       .then((success) => {
          //         console.log('successfully added picture');
          //         this.bilder$.next([...this.inspectionPoint.pictures]);
          //         this.loadingController.dismiss();
          //       }, (error) => {
          //         console.log(error);
          //         this.loadingController.dismiss();
          //       });
          //   }, (error) => {
          //     this.loadingController.dismiss();
          //   });

        }, (error) => {
          this.loadingController.dismiss();
        })
      }, (err) => {
        // Handle error
        this.loadingController.dismiss();
      });
    }
  }

  private _openCamera(): void {
    const options = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum: true,
      correctOrientation: true
    };

    this.camera.getPicture(options).then((imageData) => {
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      fetch(base64Image).then((_data) => {
        return _data.blob();
      }, (error) => {
        this.loadingController.dismiss();
      }).then((_blob) => {
        // got a blob
        // let fileName = Date.now()
        let fileName = uuid();
        if(!this.inspectionPoint.pictures){
          this.inspectionPoint.pictures = [];
        }
        this.inspectionPoint.pictures.push(fileName);

        this.protocolService.set(this.protokoll, false)
          .then((success) => {
            this.dataProvider.saveAttatchment(this.protokoll._id, fileName.toString(), _blob, 'image/png')
              .then((success) => {
                console.log('successfully added picture');
                this.bilder$.next([...this.inspectionPoint.pictures]);
                this.loadingController.dismiss();
              }, (error) => {
                console.log(error);
                this.loadingController.dismiss();
              });
          }, (error) => {
            this.loadingController.dismiss();
          });

        // this.dataProvider.updateDocument(this.protokoll)
        //   .then((success) => {
        //     this.dataProvider.saveAttatchment(this.protokoll._id, fileName.toString(), _blob, 'image/png')
        //       .then((success) => {
        //         console.log('successfully added picture');
        //         this.bilder$.next([...this.inspectionPoint.pictures]);
        //         this.loadingController.dismiss();
        //       }, (error) => {
        //         console.log(error);
        //         this.loadingController.dismiss();
        //       });
        //   }, (error) => {
        //     this.loadingController.dismiss();
        //   });

      }, (error) => {
        this.loadingController.dismiss();
      })
    }, (err) => {
      // Handle error
      this.loadingController.dismiss();
    });
  }

  private _processFile(file): void {
    let content = file.content.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
    // let fileName = Date.now();
    let fileName = uuid();
    this.inspectionPoint.pictures.push(fileName);

    this.protocolService.set(this.protokoll, false)
      .then((success) => {
        this.dataProvider.saveAttatchment(this.protokoll._id, fileName.toString(), content, file.type)
          .then((success) => {
            console.log('successfully added picture');
            this.bilder$.next([...this.inspectionPoint.pictures]);
            this.loadingController.dismiss();
          }, (error) => {
            console.log(error);
            this.loadingController.dismiss();
          });
      }, (error) => {
        this.loadingController.dismiss();
      });

    // this.dataProvider.updateDocument(this.protokoll)
    //   .then((success) => {
    //     this.dataProvider.saveAttatchment(this.protokoll._id, fileName.toString(), content, file.type)
    //       .then((success) => {
    //         console.log('successfully added picture');
    //         this.bilder$.next([...this.inspectionPoint.pictures]);
    //         this.loadingController.dismiss();
    //       }, (error) => {
    //         console.log(error);
    //         this.loadingController.dismiss();
    //       });
    //   }, (error) => {
    //     this.loadingController.dismiss();
    //   });
  }

  public save(): void {
    this.protocolService.set(this.protokoll, false);
    // this.dataProvider.updateDocument(this.protokoll);
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }

}



// WEBPACK FOOTER //
// ./src/components/pruefpunkt-add-info/pruefpunkt-add-info.ts